import React from "react";
import { MdDashboard, MdEditCalendar, MdGrading } from "react-icons/md";
import ClientOverview from "pages/client_portal/ClientOverview";
import ClientLeaves from "pages/client_portal/ClientLeaves";
import ClientEmployeeDetail from "pages/client_portal/ClientEmployeeDetail";
import Appraisals from "pages/client_portal/Appraisals";
import FillAppraisal from "pages/client_portal/FillAppraisal";
import ViewAppraisal from "pages/client_portal/ViewAppraisal";

export const clientRoutes: RoutesType[] = [
  {
    name: "Overview",
    layout: "ClientPortal",
    icon: <MdDashboard className="h-6 w-6" />,
    path: "/client-portal",
    display: true,
    permissions: ['client_management.view_my_client', 'client_management.view_my_clientuser'],
    component: <ClientOverview />,
  },
  {
    name: "Leaves",
    layout: "ClientPortal",
    icon: <MdEditCalendar className="h-6 w-6" />,
    path: "/leaves",
    display: true,
    permissions: ['client_management.view_my_client', 'client_management.view_my_clientuser'],
    component: <ClientLeaves />,
  },
  {
    name: "Employee Detail",
    layout: "ClientPortal",
    path: "/client-portal/employee/:employeeId",
    display: false,
    permissions: ['client_management.view_my_client', 'client_management.view_my_clientuser'],
    component: <ClientEmployeeDetail />,
  },
  {
    name: "Performance & Development",
    layout: "ClientPortal",
    icon: <MdGrading className="h-6 w-6" />,
    path: "/client-appraisals",
    display: true,
    permissions: ['appraisal_response.view_appraisalresponse'],
    component: <Appraisals />,
  },
  {
    name: "View Appraisal",
    layout: "ClientPortal",
    path: "/client-appraisals/response/:responseId",
    display: false,
    permissions: ['appraisal_response.view_appraisalresponse'],
    component: <ViewAppraisal />,
  },
  {
    name: "Fill Appraisal",
    layout: "ClientPortal",
    path: "/client-appraisals/:cycleId/employee/:employeeId",
    display: false,
    permissions: ['appraisal_response.add_appraisalresponse', 'appraisal_response.change_appraisalresponse'],
    component: <FillAppraisal />,
  },
];
